import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticatedUserService, UserService } from '@markant-platform/shared/user/data-access';
import { Breadcrumb } from '@markant-platform/shared/breadcrumb/feature';
import { catchError, EMPTY, map, Observable, switchMap } from 'rxjs';
import { SnackbarService } from '@markant-platform/shared/snackbar/feature';

@Injectable({
  providedIn: 'root',
})
export class OrganizationMemberDetailsBreadcrumbResolver {
  constructor(
    private readonly authenticatedUserService: AuthenticatedUserService,
    private readonly userService: UserService,
    private readonly snackbarService: SnackbarService
  ) {}

  resolve(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): Observable<Breadcrumb[]> {
    const userId: string = route.paramMap.get('userId') as string;
    const organizationId: string | null = route.paramMap.get('organizationId');

    return organizationId
      ? this.getBreadcrumb(userId, organizationId)
      : this.getBreadcrumbForOrganizationFromToken(userId);
  }

  private getBreadcrumb(userId: string, organizationId: string): Observable<Breadcrumb[]> {
    return this.userService.getUserForOrganization(userId, organizationId).pipe(
      map(user => {
        return [{ url: user.id, label: `${user.firstname} ${user.lastname}` }];
      }),
      catchError(_ => {
        this.snackbarService.showErrorSnackbarWithTransloco('error.data');
        return EMPTY;
      })
    );
  }

  private getBreadcrumbForOrganizationFromToken(userId: string): Observable<Breadcrumb[]> {
    return this.authenticatedUserService
      .getOrganizationId()
      .pipe(switchMap(tokenOrganizationId => this.getBreadcrumb(userId, tokenOrganizationId)));
  }
}
